const defaultState = {
    payload: {
        options: [],
    },
    errors: {},
};

export const sortDropdown = (state = defaultState) => state;
